function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
import Promise from "bluebird";
import { fetchContent, setKeyValue, deleteKeyValue, goToSlide, completeSlide, sendNotification } from "../actions";
import SocialViewActionCreators from "../actions/SocialViewActionCreators";
import Store from "../store";
import omit from "lodash/omit";
import { getPluginAssets, createPluginAsset, updatePluginAsset, deletePluginAsset } from "./api/SocialRemote";
import { NotLoggedInError, NotAuthorizedError, DisclaimerNotEndorsedError } from "./error";
var getCurrentCBookState = function(store) {
    var state = store.getState();
    var api = state.api;
    var student = api && api.getStudent();
    var cbook = state.cbook;
    var chart = state.nodes.find(function(node) {
        return node.id === state.currentSlide;
    });
    return {
        name: (cbook === null || cbook === void 0 ? void 0 : cbook.name) || "",
        chartName: chart === null || chart === void 0 ? void 0 : chart.name,
        storyMode: true,
        language: (cbook === null || cbook === void 0 ? void 0 : cbook.default_ui_language) || (cbook === null || cbook === void 0 ? void 0 : cbook.default_frontend_language) || "en",
        theme: (cbook === null || cbook === void 0 ? void 0 : cbook.theme) || "light",
        iconUrl: cbook === null || cbook === void 0 ? void 0 : cbook.icon_url,
        student_id: student === null || student === void 0 ? void 0 : student.id,
        student_name: student === null || student === void 0 ? void 0 : student.name,
        isPreviewMode: false
    };
};
var waitForContent = function(scope) {
    return new Promise(function(resolve, reject) {
        var tries = 0;
        var tryit = function() {
            var state = Store.getState();
            var _content = state.contents[scope.chartId || state.currentSlide];
            if (_content) {
                resolve(_content);
            } else if (tries < 3) {
                setTimeout(tryit, 50);
            } else {
                reject(new Error("No Content available"));
            }
        };
        tryit();
    });
};
var socialAction = function(successFn) {
    var isEndoresed = function() {
        var socialConfig = Store.getState().socialConfig;
        var session = Store.getState().session;
        return session && socialConfig.disclaimer && (!socialConfig.disclaimer.needs_endorsement || socialConfig.disclaimer.needs_endorsement && session.is_disclaimer_endorsed);
    };
    return new Promise(function(resolve, reject) {
        var trys = 0;
        var checkState = function() {
            if (isEndoresed()) {
                resolve(successFn());
            } else {
                if (trys > 20) {
                    var socialConfig = Store.getState().socialConfig;
                    var session = Store.getState().session;
                    if (!session) {
                        reject(new NotLoggedInError());
                    } else if (socialConfig.disclaimer.needs_endorsement && !session.is_disclaimer_endorsed) {
                        reject(new DisclaimerNotEndorsedError());
                    } else {
                        reject(new NotAuthorizedError());
                    }
                } else {
                    trys++;
                    setTimeout(checkState, 20);
                }
            }
        };
        checkState();
    });
};
var socialDataStruct = function() {
    var rawData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        meta: omit(rawData, [
            "data",
            "id",
            "node_id"
        ]),
        data: rawData.data
    };
};
export default {
    getCurrentData: function getCurrentData(scope, type) {
        var state = Store.getState();
        switch(type){
            case "chart":
                var content = state.contents[scope.chartId || state.currentSlide];
                var _cont = {};
                if (content) {
                    if (typeof content.cont === "string") {
                        _cont = JSON.parse(content.cont.length ? content.cont : "{}");
                    } else {
                        _cont = content.cont;
                    }
                    _cont.status = state.api && state.api.getSlideStatus(scope.chartId || state.currentSlide);
                } else {
                    Store.dispatch(fetchContent({
                        id: scope.chartId || state.currentSlide
                    }));
                }
                return Promise.resolve(_cont);
            case "cbook":
                return Promise.resolve(getCurrentCBookState(Store));
            case "claims":
                var claims = state.claims[scope.chartId || state.currentSlide] || [];
                return Promise.resolve(claims.map(function(c) {
                    return {
                        local_id: c.local_id,
                        claim_type: c.claim_type
                    };
                }));
            default:
                return Promise.reject(new Error('Unknown Data type "'.concat(type, '", should be "cbook", "chart" or "claims"')));
        }
    },
    getUserData: function getUserData(scope) {
        var state = Store.getState();
        var action = function(content) {
            return socialAction(function() {
                return SocialViewActionCreators.getNodePluginData(String(content.extension_id), scope.chartId || state.currentSlide).then(function(data) {
                    return socialDataStruct(data);
                }, function(error) {
                    return error;
                });
            });
        };
        return waitForContent(scope).then(action);
    },
    setUserData: function setUserData(scope, data) {
        var state = Store.getState();
        return waitForContent(scope).then(function(content) {
            return SocialViewActionCreators.saveNodePluginData(String(content.extension_id), scope.chartId || state.currentSlide, JSON.stringify(data));
        });
    },
    getUserProfile: function getUserProfile(scope) {
        return socialAction(function() {
            return SocialViewActionCreators.getUserProfile();
        });
    },
    setUserProfile: function setUserProfile(scope, data) {
        return socialAction(function() {
            return SocialViewActionCreators.setUserProfile(data);
        });
    },
    getCommunityData: function getCommunityData(scope) {
        var state = Store.getState();
        var action = function(content) {
            return socialAction(function() {
                return SocialViewActionCreators.getCommunityPluginData(String(content.extension_id), scope.chartId || state.currentSlide).then(function(data) {
                    return data.filter(function(ud) {
                        var user = Store.getState().session;
                        return user && ud && ud.user && ud.user.id !== user.id;
                    }).map(socialDataStruct);
                }, function(error) {
                    return error;
                });
            });
        };
        return waitForContent(scope).then(action);
    },
    getClaims: function getClaims(scope) {
        var state = Store.getState();
        var claims = state.claims[scope.chartId || state.currentSlide] || [];
        return Promise.resolve(claims);
    },
    resolveClaim: function resolveClaim(scope, id) {
        var state = Store.getState();
        var claims = state.claims[scope.chartId || state.currentSlide] || [];
        var claim = claims.find(function(c) {
            return id === c.local_id;
        });
        if (claim && claim.url) {
            var _claim = _objectSpread({}, claim);
            _claim.url = "../../../".concat(_claim.url[0] === "/" ? _claim.url.substr(1) : _claim.url);
            return _claim;
        }
        return undefined;
    },
    getValueFromKey: function getValueFromKey(scope, keys) {
        var state = Store.getState();
        var keyValStore = _objectSpread({}, state.keyValueStore);
        var isA = Array.isArray(keys);
        if (!isA) {
            keys = [
                keys
            ];
        }
        var values = {};
        keys.filter(function(k) {
            return keyValStore.hasOwnProperty(k);
        }).forEach(function(k) {
            return values[k] = keyValStore[k];
        });
        var missingKeys = keys.filter(function(k) {
            return !keyValStore.hasOwnProperty(k);
        });
        var invalidKeys = keys.filter(function(k) {
            return typeof k !== "string";
        });
        return !invalidKeys.length ? {
            values: values,
            missingKeys: missingKeys
        } : {
            error: true,
            msg: 'unsupported keys "'.concat(invalidKeys.join(", "), '" - types "').concat(invalidKeys.map(function(k) {
                return typeof k === "undefined" ? "undefined" : _typeof(k);
            }).join(", "), '"')
        };
    },
    setKeyValue: function setKeyValue1(scope, key, value) {
        Store.dispatch(setKeyValue({
            key: key,
            value: value
        }));
        return value;
    },
    deleteKey: function deleteKey(scope, key) {
        Store.dispatch(deleteKeyValue({
            key: key
        }));
        return true;
    },
    jumpToChart: function jumpToChart(scope, localId) {
        var state = Store.getState();
        if (typeof localId === "string") {
            localId = parseInt(localId.split("-")[1] || localId.split("-")[0], 10);
        }
        Store.dispatch(goToSlide({
            localId: localId,
            origin: scope.chartId || state.currentSlide
        }));
    },
    sendNotification: function sendNotification1(scope, notification) {
        var type = notification.type, rest = _objectWithoutProperties(notification, [
            "type"
        ]);
        Store.dispatch(sendNotification(_objectSpreadProps(_objectSpread({}, rest), {
            notificationType: type
        })));
    },
    readyToPrint: function readyToPrint(scope) {
        if (scope.frame) {
            var event = scope.frame.contentWindow.document.createEvent("Event");
            event.initEvent("printable", true, true);
            scope.frame.contentWindow.dispatchEvent(event);
        } else {
            console.warn("Scope has no iFrame attached");
        }
    },
    includeThemeCSS: function includeThemeCSS(scope) {
        if (scope.frame) {
            var insertCSS = function(link) {
                if (link) {
                    var node = link.cloneNode();
                    var href = node.getAttribute("href");
                    if (href) {
                        var _scope_frame, _scope_frame_contentWindow;
                        var omitSlash = function(str) {
                            return str[0] === "/" ? str.substr(1) : str;
                        };
                        node.setAttribute("href", "../../../".concat(omitSlash(href)));
                        node.setAttribute("rel", "stylesheet");
                        node.setAttribute("blocking", "render");
                        if ((_scope_frame = scope.frame) === null || _scope_frame === void 0 ? void 0 : (_scope_frame_contentWindow = _scope_frame.contentWindow) === null || _scope_frame_contentWindow === void 0 ? void 0 : _scope_frame_contentWindow.document.head) {
                            scope.frame.contentWindow.document.head.appendChild(node);
                        }
                    } else {
                        console.warn("CSS (".concat(link, ") : href empty!"));
                    }
                }
            };
            insertCSS(document.querySelector('link[href$="theme.css"]'));
            insertCSS(document.querySelector('link[href$="client.css"]'));
            insertCSS(document.querySelector('link[href$="accessibility.css"]'));
            insertCSS(document.querySelector('link[href$="last.css"]'));
        } else {
            console.warn("Scope has no iFrame attached");
        }
    },
    getThemeCSS: function getThemeCSS(scope) {
        var themeLink = document.querySelector('link[href$="theme.css"]');
        var overwriteLink = document.querySelector('link[href$="client.css"]');
        var accessibilityLink = document.querySelector('link[href$="accessibility.css"]');
        var lastLink = document.querySelector('link[href$="last.css"]');
        return {
            theme: themeLink === null || themeLink === void 0 ? void 0 : themeLink.href,
            overwrite: overwriteLink === null || overwriteLink === void 0 ? void 0 : overwriteLink.href,
            accessibility: accessibilityLink === null || accessibilityLink === void 0 ? void 0 : accessibilityLink.href,
            last: lastLink === null || lastLink === void 0 ? void 0 : lastLink.href
        };
    },
    completeChart: function completeChart(scope) {
        var state = Store.getState();
        Store.dispatch(completeSlide({
            id: scope.chartId || state.currentSlide
        }));
    },
    getFiles: function getFiles(scope) {
        var state = Store.getState();
        var content = state.contents[scope.chartId || state.currentSlide];
        return !content ? Promise.reject(new Error("No Content available")) : socialAction(function() {
            return getPluginAssets(String(content.extension_id), scope.chartId || state.currentSlide, false);
        });
    },
    getCommunityFiles: function getCommunityFiles(scope) {
        var state = Store.getState();
        var content = state.contents[scope.chartId || state.currentSlide];
        return !content ? Promise.reject(new Error("No Content available")) : socialAction(function() {
            return getPluginAssets(String(content.extension_id), scope.chartId || state.currentSlide, true);
        });
    },
    updateFile: function updateFile(scope, items, onProgress) {
        var state = Store.getState();
        var content = state.contents[scope.chartId || state.currentSlide];
        return !content ? Promise.reject(new Error("No Content available")) : socialAction(function() {
            return updatePluginAsset(String(content.extension_id), scope.chartId || state.currentSlide, items, onProgress);
        });
    },
    uploadFile: function uploadFile(scope, files, onProgress) {
        var state = Store.getState();
        var content = state.contents[scope.chartId || state.currentSlide];
        return !content ? Promise.reject(new Error("No Content available")) : socialAction(function() {
            return createPluginAsset(String(content.extension_id), scope.chartId || state.currentSlide, files, onProgress);
        });
    },
    removeFile: function removeFile(scope, ids) {
        var state = Store.getState();
        var content = state.contents[scope.chartId || state.currentSlide];
        return !content ? Promise.reject(new Error("No Content available")) : socialAction(function() {
            return deletePluginAsset(String(content.extension_id), scope.chartId || state.currentSlide, ids);
        });
    }
};
